<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in" [innerHTML]="label"></h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-xs-12" style="max-height: 500px; overflow-y: scroll">
            <app-candidate-job-match-profile
                [jobId]="modalData.jobId"
                [candidateId]="modalData.candidateId"
                [jobMatchId]="modalData.jobMatchId"
                context="candidateJobComparison">
            </app-candidate-job-match-profile>
        </div>
    </div>
</div>
